<template>
    <div>
        <v-dialog v-model="viewDialog" persistent fullscreen>
            <v-overlay :value="overlay">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>

            <v-card>
                <v-card-title class="dialog-header" style="background-color: #84B628;">
                    <span class="headline" style="color: #ffffff">{{ $t('detailInformation')}}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        text
                        icon
                        @click="handleClose"
                        valid="false"
                        v-shortkey="['esc']"
                        @shortkey.native="handleClose"
                    >
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text style="margin:0; padding: 0">
                    <!-- Profile -->
                    <v-row>
                        <v-col class="d-flex justify-center">
                            <img style="width 200px; height: 110px" :src="headers.profile" @error="imageUrlAlt" alt="profile">
                        </v-col>
                    </v-row>

                    <!-- Step -->
                        <div v-if="tab_type === 'personal_information'" class="cart-step">
                            <div class="line-step">
                                <ul>
                                    <li v-for="(item, item_key) in headers.steps" :key="item_key"></li>
                                </ul>
                            </div>

                            <div class="circle-step">
                                <ul>
                                    <li v-for="(item, item_key) in headers.steps" :key="item_key" >
                                        <div class="circle" :style="'background-color:' + item.color">
                                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQflBgYKLR73xGi3AAAAuklEQVRIx+2TPw5EQBxGZy9CnIJKIuEMCpWonEjvJgq3EKHUkYjOvC2EtdnCn8wkW/j6eS+/L98I8eQgLx1QsCwhskyIstQCh6YBgL7XCJ9niGN1cGkYUNcLXEpI0weuG26a/wGHPEdWFdK2T8F/ppgkBw+6bv0UR5LL8OVc34dpOpIs8La9BP9IXBc5jpsEx7nd+TnJMKwSpWtBBsFXXYTh7VrOXbJG+c73EsXwTYLnQVFAFCmHP9nnDbvPd2M2JUkGAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA2LTA2VDEwOjQ1OjMwKzAwOjAwkIk+lgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wNi0wNlQxMDo0NTozMCswMDowMOHUhioAAAAASUVORK5CYII=" alt="step">
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="circle-step-label">
                                <ul>
                                    <li v-for="(item, item_key) in headers.steps" :key="item_key"><h6>{{ item.value }}</h6></li>
                                </ul>
                            </div>
                        </div>

                   <!-- Tab Menu -->
                    <v-tabs
                        class="mt-6"
                        background-color="#84B628"
                        dark
                        show-arrows
                        v-model="tab_actived"
                        center-active
                        centered
                    >

                        <v-tab v-for="(tab, index) in tabs" :key="tab.id" @click="tab_type = tab.id; tab_actived = index">{{ tab.name }}</v-tab>

                        <v-tab-item class="mt-10" v-for="tab in tabs" :key="tab.id">
                            <v-overlay :value="overlay_tab"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
                            <membership-personal-information v-if="tab_type === 'personal_information'"></membership-personal-information>
                            <membership-career-information v-else-if="tab_type === 'career_information'"></membership-career-information>
                            <membership-career-information v-else-if="tab_type === 'agricultural_cooperatives_information'"></membership-career-information>
                            <membership-ability-using-phone-information v-else-if="tab_type === 'ability_use_phone_information'"></membership-ability-using-phone-information>
                            <membership-experience-information v-else-if="tab_type === 'experience'"></membership-experience-information>
                            <membership-document-information v-else-if="tab_type === 'document_information'"></membership-document-information>
                        </v-tab-item>
                    </v-tabs>

                    <!-- Button option -->
                        <div v-if="tab_type === 'personal_information' && headers.buttons.length" class="button-action-container" :style="$vuetify.breakpoint.mobile ? 'width: 100%; transform: translate(-50%, 0%);' : 'width: 1024px;'">
                            <v-btn 
                            style="color: #ffffff; text-transform: capitalize; margin-left: 5px;" 
                            small rounded depressed 
                            :color="button.color" 
                            @click="handleApprovalDialog(button.id)"
                            v-for="(button, index_button) in headers.buttons" 
                            :key="index_button">
                                {{ button.value }}
                            </v-btn>
                        </div>

                </v-card-text>

                
            </v-card>

        </v-dialog>

         <v-dialog v-model="approval_dialog" persistent style="z-index: 999 !important" width="50%">
           <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        text
                        icon
                        @click="approval_dialog = false"
                        valid="false"
                    >
                        <v-icon dark>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="text-center">
                    <div v-if="['submit','review', 'approval', 'undo_reject'].includes(approvals.status)">
                        <img src="data:image/png;base64,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" alt="">
                        <h1 class="mt-3 mb-2">{{ $t('areYouSure') }}</h1>
                    </div>

                    <div v-else style="margin-top: 20px;">
                        <v-textarea
                            clearable
                            outlined
                            :placeholder="$t('yourDesc')"
                            v-model="approvals.note"
                            clear-icon="mdi-close-circle"
                            rows="7"
                            auto-grow
                            :label="$t('reason')"
                        ></v-textarea>
                    </div>


                </v-card-text>

                <v-card-actions class="pb-10 px-10">
                    <v-spacer></v-spacer>
                    <v-btn rounded color="primary" @click="fetchApproval()" :loading="loadingApproval">{{$t("yes")}}</v-btn>
                    <v-btn rounded @click="approval_dialog = false">{{$t("close")}}</v-btn>
                </v-card-actions>
           </v-card>
        </v-dialog>
    </div>
</template>


<script>

    import OptionDataMixin from "../../../../mixins/optionDataMixin";
    import MainMixin from "../../../../mixins/mainMixin";
    import ValidatorMixin from "../../../../mixins/validatorMixin";
    import {provider} from "@/service/provider";
    import axios from "axios";
    import membershipPersonalInformation from './membershipPersonalInformation.vue';
    import membershipCareerInformation from './membershipCareerInformation.vue';
    import membershipAbilityUsingPhoneInformation from './membershipAbilityUsingPhoneInformation.vue';
    import membershipExperienceInformation from './membershipExperienceInformation.vue';
    import membershipDocumentInformation from './membershipDocumentInformation.vue';

    export default {
        name: "viewMembershipModal",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        components: {membershipPersonalInformation, membershipCareerInformation, membershipAbilityUsingPhoneInformation, membershipExperienceInformation, membershipDocumentInformation},

        data() {
            return {
                approval_dialog: false,
                loadingApproval: false,
                approvals: {
                    user_id: "",
                    member_id: "",
                    note: "",
                    status: "",
                },

                overlay_tab: false,
                tab_actived: '',
                tab_type: '',
                tabs: [],
                formDoc: {}
            };
        },

        methods: {
            
            reset() {},

            handleClose(){
                this.$store.dispatch('updateViewMembershipDialog', {view_dialog: false, member_id: '', customer_type: ''});
            },

            async fetchMembershipTab(){
                

                let url = provider.baseURL + provider.getListContactPersonalTab;

                await axios.post(url, {customer_type: this.$store.state.membership.customer_type}, {headers: {Authorization: localStorage.token, "x-localization": this.language}}).then(res => {
                    if (res.data.response && res.data.response.code === 200) {
                        this.tabs = res.data.data[0].value;
                    }   
                }).catch(error => {
                    this.overlay = false;
                    console.log(error)
                });
            },

            imageUrlAlt(event) {
                event.target.src = require("../../../../assets/user.png");
            },

            handleApprovalDialog(status){
                this.approvals.user_id   = this.$store.state.userDoc.id;
                this.approvals.member_id = this.$store.state.membership.member_id;
                this.approvals.status    = status;
                this.approvals.note      = '';
                this.approval_dialog     = true;
            },

            async fetchApproval(){
                this.loadingApproval = true;
                let url = provider.baseURL + provider.approvalMembership;

                await axios.post(url, this.approvals, {headers: {Authorization: localStorage.token}}).then(res => {
                    if (res.data.response && res.data.response.code === 200) {
                        this.loadingApproval = false;
                        this.approval_dialog = false;
                        this.tab_type = '';
                        this.$nextTick(() => {
                            this.tab_type = 'personal_information';
                        });
                    }   
                }).catch(error => {
                    this.loadingApproval = false;
                    console.log(error)
                });
            }
        },

        watch: {
            viewDialog(val) {
                this.tab_type = '';
                if (val === false) { this.reset(); }
                else {
                    this.fetchMembershipTab();
                    this.tab_type    = 'personal_information';
                    this.tab_actived = 0;
                }
            },

            async tab_type(tab){
                if(tab){
                    this.overlay_tab = true;
                    let link = '';
                    switch(tab){
                        case 'personal_information':                    link = provider.getDetailContactPersonal; break;
                        case 'agricultural_cooperatives_information':   link = provider.getDetailContactCompany; break;
                        case 'career_information':                      link = provider.getDetailContactCareer; break;
                        case 'ability_use_phone_information':           link = provider.getDetailContactPhoneSkill; break;
                        case 'experience':                              link = provider.getDetailContactExperience; break;
                        case 'document_information':                    link = provider.getDetailFileContactDocument; break;
                    }

                    let url     = provider.baseURL + link;
                    let params  = {};
                    if(tab == 'personal_information') { params = { member_id: this.$store.state.membership.member_id }
                    }else{ params = { contact_id: this.$store.state.membership.member_id }}

                    this.$store.dispatch('updateViewMembershipDialogTabItem', {tab_items: [], tab_items_loading: true});
                    await axios.post(url, params, {headers: {Authorization: localStorage.token, 'x-localization': this.language}}).then(res => {
                        if (res.data.response && res.data.response.code === 200) {
                            this.overlay_tab = false;
                            this.$store.dispatch('updateViewMembershipDialogTabItem', {tab_items: res.data.data, tab_items_loading: false});

                            this.$nextTick(() => {

                                if(this.tab_type == 'personal_information'){
                                    let steps   = [];
                                    let profile = '';
                                    let buttons = [];

                                    let result_step = res.data.data.filter(arrs => {
                                        return arrs.id === 'status';
                                    });
    
                                    if(result_step.length){
                                        steps = result_step[0].value;
                                    }

                                    let result_profile = res.data.data.filter(arrs => {
                                        return arrs.id === 'profile';
                                    });
    
                                    if(result_profile.length){
                                        profile = result_profile[0].value.url;
                                    }

                                    let result_button = res.data.data.filter(arrs => {
                                        return arrs.id === 'button';
                                    });
    
                                    if(result_button.length){
                                        buttons = result_button[0].value;
                                    }

                                    this.$store.dispatch('updateViewMembershipHeader', {steps: steps, profile: profile, buttons: buttons});
                                }

                            });
                        }   
                    }).catch(error => {
                        this.overlay_tab = false;
                        console.log(error)
                    });
                }
            },

        },
        computed: {
            viewDialog(){
                return this.$store.state.membership.view_dialog;
            }, 
            
            headers(){
               return this.$store.state.membership.headers;
            }
        },
    };
</script>

<style scoped>
    .v-tab {
        text-transform: none !important;
    }
    .cart-step .line-step,
    .cart-step .circle-step,
    .cart-step .circle-step-label {
        position: relative;
    }

    .cart-step .line-step ul, 
    .cart-step .circle-step ul 
    {
        display: flex;
        position: relative;
        width: 550px;
        left: 50%;
        transform: translateX(-50%);
    }

    .cart-step .line-step ul  {
        top: 21px;
        height: 6px;
        box-shadow: 0 0px 4px -1px grey;
    }
    .cart-step .circle-step ul  {
        justify-content: space-between;
        z-index: 1;
    }

    .cart-step .line-step ul li {
        flex: 1;
        list-style: none;
    }

    .cart-step .circle-step ul li {
        list-style: none;
    }
    .cart-step .circle-step ul li .circle {
        width: 35px;
        height: 35px;
        border-radius: 40px;
    }

    .cart-step .circle-step-label ul {
        display: flex;
        position: relative;
        width: 680px;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 5px;
    }

    .cart-step .circle-step-label ul li{
        display: flex;
        flex: 1;
        justify-content: center;
        list-style: none;
    }

    .cart-step .circle-step-label ul li h6 {
        font-size: 14px;
    }   

    .cart-step .circle-step ul li .circle img {
        width: 20px;
        height: 20px;
        display: inline;
        margin-top: 7px;
        margin-left: 7px;
    }


    .button-action-container {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        background: #ffffff;
        box-shadow: 0 0px 4px -1px grey;
        padding: 10px;
        /* position the div in center */
        position: fixed;
        bottom: 0%;
        left: 50%;
        transform: translate(-50.8%, 0%);
    }
   
</style>
